<template>
	<div v-if="show_body" class="wechat_m text-center">
		<h2 class="h2">{{data.uname}}你好！我是本次辅导的咨询师{{data.tname}}。</h2>
		<h3>请扫描下方二维码添加为好友，我们的咨询将准时开始，预计进行 1-‐1.5 小时，请找一个安静不被打扰且网络信号稳定的环境耐心等待！</h3>
		<img :src="data.qrcode" alt="" />
	</div>
</template>
<script>
	import { wxcoach } from '@/api/totoring'
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				show_body: false,
				data: {}
			}
		},
		methods: {
			pullData(){
				wxcoach()
					.then((data) => {
						this.data = data;
						this.show_body = true;
						shareCon("totoring",this);
					})
			}
		},
		created(){
			this.pullData();
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/remChange.scss";
	.wechat_m{
    width: 100%;
    text-align: center;
    padding-top: changeRem(1.4)+px;
    h2{
	    color: #EB5032;
	    font-size: changeRem(0.64)+px;
	    line-height: changeRem(0.8)+px;
    }
    h3{
	    width: changeRem(13)+px;
  		margin: changeRem(0.8)+px auto 0;
  		color: #666;
	    font-size: changeRem(0.52)+px;
	    line-height: changeRem(0.72)+px;
    }
    img{
    	width: changeRem(8.52)+px;
	    height: changeRem(8.52)+px;
	    vertical-align: middle;
	    margin: 0 auto;
	    margin-top: changeRem(0.96)+px;
    }
	}
</style>